import {FC, PropsWithChildren, useEffect, useRef} from 'react'
import {useScreenSize} from '../hooks/useScreenSize'

export const VisualViewPortWrapper: FC<PropsWithChildren> = ({children}) => {
  const {isMobile} = useScreenSize()

  const body = useRef(document.body)

  const onReziseHandler = () => {
    if (!isMobile) {
      body.current.style.height = '100vh'
      return
    }

    const h = window.visualViewport?.height
    body.current.style.height = h ? `${h}px` : '100vh'
  }

  useEffect(() => {
    if (isMobile) {
      body.current.style.overflow = 'hidden'
      body.current.style.height = window.visualViewport?.height
        ? `${window.visualViewport.height}px`
        : '100vh'

      window.visualViewport?.addEventListener('resize', onReziseHandler)
    }
    return () => window.visualViewport?.removeEventListener('resize', onReziseHandler)
  }, [])

  return <>{children}</>
}
